(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('yds-stacked-header')) {
  customElements.define('yds-stacked-header', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.header = this.querySelector('[data-header-height]');
        if (!this.header) return;
        this.sync = () => {
          const height = this.header.offsetHeight;
          if (!height || height === this.lastHeight) return;
          this.lastHeight = height;
          // Keep the section in flow when Pipeline fixes the header on scroll.
          this.style.minHeight = height + 'px';
          // Pipeline owns dropdown, drawer and sticky offsets; refresh its measurements.
          document.dispatchEvent(new CustomEvent('theme:resize'));
        };
        this.observer = new ResizeObserver(this.sync);
        this.observer.observe(this.header);
        this.sync();
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-fern-commercial"] && !Shopify.designMode) return;
  try {
    

function initNativeFern(scope=document){scope.querySelectorAll('[data-native-fern]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const thumbs=root.querySelectorAll('[data-nf-thumb]'),panels=root.querySelectorAll('[data-nf-panel]');thumbs.forEach(button=>button.addEventListener('click',()=>{thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));panels.forEach(panel=>panel.hidden=panel.dataset.nfPanel!==button.dataset.nfThumb)}));const add=root.querySelector('[data-nf-add]'),list=root.querySelector('.nf-pane-list');if(add&&list){add.addEventListener('click',()=>{const count=list.children.length+1;if(count>12)return;const next=list.firstElementChild.cloneNode(true);next.querySelectorAll('input').forEach(input=>{const old=input.id;input.id=old.replace(/-1$/,`-${count}`);input.name=input.name.replace('Window 1 ',`Window ${count} `);input.value=input.id.includes('-qty-')?'1':'';const label=next.querySelector(`label[for="${old}"]`);if(label)label.htmlFor=input.id});list.append(next);next.querySelector('input').focus();if(count>=12)add.disabled=true})}root.querySelectorAll('a[href^="#nf-"]').forEach(link=>link.addEventListener('click',event=>{const target=document.getElementById(link.hash.slice(1));if(!target)return;event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});}))})}
initNativeFern();document.addEventListener('shopify:section:load',()=>initNativeFern());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yds-cart"]) return;
  try {
    
  if (!customElements.get('yds-cart')) {
    customElements.define('yds-cart', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true; this.dataset.controllerBuild = '11';
        this.config = JSON.parse(this.querySelector('[data-yc-config]').textContent);
        this.cart = this.config.cart;
        this.s = this.config.strings;
        this.root = window.Shopify?.routes?.root || '/';
        this.previewId = this.config.preview_id || new URLSearchParams(window.location.search).get('preview_theme_id');
        this.queue = Promise.resolve();
        this.pending = new Map();
        this.version = 0;
        this.savedNote = this.cart.note || '';
        this.setAttribute('data-enhanced', '');
        this.addEventListener('click', event => this.click(event));
        this.addEventListener('change', event => this.change(event));
        this.addEventListener('input', event => this.input(event));
        this.addEventListener('focusout', event => { if (event.target.matches('[data-yc-quantity]')) this.change(event); });
        this.addEventListener('submit', event => this.submit(event));
        this.note = this.querySelector('[data-yc-note]');
        this.note?.addEventListener('blur', () => this.scheduleNote(0));
        const country = this.querySelector('[name="country"]');
        if (country) {
          const seen = new Set();
          [...country.options].forEach(option => {
            if (option.value === '---' || seen.has(option.value)) option.remove();
            else seen.add(option.value);
          });
          country.value = this.dataset.country; this.provinces();
        }
        this.externalChange = event => {
          if (!event.detail?.cart || this.busy || this.pending.size) return;
          const next = event.detail.cart;
          if (this.fingerprint(next) !== this.fingerprint(this.cart)) {
            this.clearEstimate(this.s.changed);
            this.enqueue(async () => { await this.refresh(); });
          }
        };
        document.addEventListener('theme:cart:change', this.externalChange);
        this.returned = event => { if (event.persisted) this.enqueue(async () => { this.clearEstimate(); await this.refresh(); }); };
        window.addEventListener('pageshow', this.returned);
      }
      disconnectedCallback() {
        document.removeEventListener('theme:cart:change', this.externalChange);
        window.removeEventListener('pageshow', this.returned);
        clearTimeout(this.quantityTimer); clearTimeout(this.noteTimer);
        this.shippingAbort?.abort();
      }
      fingerprint(cart) { return JSON.stringify([cart.total_price, cart.currency, (cart.items || []).map(item => [item.key, item.quantity])]); }
      identity(item) { return JSON.stringify([item.variant_id || item.id, item.selling_plan_allocation?.selling_plan?.id || null, Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b))]); }
      click(event) {
        const step = event.target.closest('[data-yc-step]');
        const remove = event.target.closest('[data-yc-remove]');
        if (!step && !remove) return;
        event.preventDefault();
        if (this.busy) return;
        const row = (step || remove).closest('[data-yc-item]');
        const input = row.querySelector('[data-yc-quantity]');
        const amount = remove ? 0 : Math.max(0, Number(input.value || 0) + Number(step.dataset.ycStep));
        input.value = amount;
        this.scheduleQuantity(row, amount, remove ? 0 : 200);
      }
      change(event) {
        if (event.target.matches('[data-yc-quantity]')) {
          if (!event.target.value.trim()) { this.error(this.s.quantity_error); return; }
          this.scheduleQuantity(event.target.closest('[data-yc-item]'), Number(event.target.value), 0);
        }
        if (event.target.matches('[name="country"]')) this.provinces();
        if (event.target.matches('[data-yc-destination]')) this.clearEstimate();
        if (event.target.matches('[data-yc-rate]')) this.displayRate(event.target.value === '' ? -1 : Number(event.target.value));
      }
      input(event) {
        if (event.target.matches('[data-yc-quantity]') && event.target.value.trim()) this.scheduleQuantity(event.target.closest('[data-yc-item]'), Number(event.target.value), 400);
        if (event.target.matches('[data-yc-note]')) this.scheduleNote(350);
        if (event.target.matches('[data-yc-destination]')) { event.target.setCustomValidity(''); this.clearEstimate(); }
      }
      scheduleQuantity(row, quantity, delay) {
        if (this.busy) return;
        if (!Number.isSafeInteger(quantity) || quantity < 0) { this.error(this.s.quantity_error); return; }
        const item = this.cart.items.find(item => item.key === row.dataset.key);
        if (!item) { this.error(this.s.error); return; }
        if (quantity === item.quantity) { this.error(''); return; }
        this.pending.set(this.identity(item), quantity);
        this.clearEstimate(this.s.changed);
        clearTimeout(this.quantityTimer);
        this.quantityTimer = setTimeout(() => this.flushQuantities(), delay);
      }
      flushQuantities() {
        clearTimeout(this.quantityTimer);
        if (!this.pending.size) return this.queue;
        const changes = [...this.pending]; this.pending.clear();
        return this.enqueue(async () => {
          const focus = document.activeElement;
          const focusKey = focus?.closest('[data-yc-item]')?.dataset.key;
          const focusItem = this.cart.items.find(item => item.key === focusKey);
          const focusIdentity = focusItem && this.identity(focusItem);
          const focusStep = focus?.dataset.ycStep;
          const focusQuantity = focus?.matches('[data-yc-quantity]');
          this.busy = true; this.disable(true); this.error(''); this.status(this.s.saving);
          try {
            for (const [identity, quantity] of changes) {
              const item = this.cart.items.find(item => this.identity(item) === identity);
              if (!item) continue;
              const data = await this.request('cart/change.js', {id:item.key, quantity, sections:[this.dataset.section], sections_url:this.sectionUrl().pathname + this.sectionUrl().search});
              try { this.render(data); this.cart = data; } catch (renderError) { await this.refresh(); }
            }
            this.status(this.s.saved);
            document.dispatchEvent(new CustomEvent('theme:cart:change', {detail:{cart:this.cart}, bubbles:true}));
          } catch (error) {
            await this.refresh().catch(() => {});
            this.failedSave = true; this.error(error.customerMessage || this.s.error); this.status('');
          } finally {
            this.busy = false; this.disable(false);
            if (focusIdentity) {
              const item = this.cart.items.find(item => this.identity(item) === focusIdentity);
              const row = item && [...this.querySelectorAll('[data-yc-item]')].find(row => row.dataset.key === item.key);
              const target = focusQuantity ? row?.querySelector('[data-yc-quantity]') : focusStep ? row?.querySelector('[data-yc-step="' + focusStep + '"]') : null;
              target?.focus({preventScroll:true});
            }
          }
        });
      }
      enqueue(task) { this.queue = this.queue.catch(() => {}).then(task); return this.queue; }
      disable(disabled) {
        this.querySelector('[data-yc-items]').setAttribute('aria-busy', String(disabled));
        this.querySelectorAll('[data-yc-quantity],[data-yc-step]').forEach(el => el.disabled = disabled);
        this.querySelectorAll('[data-yc-remove]').forEach(el => el.setAttribute('aria-disabled', String(disabled)));
      }
      status(message) { this.querySelector('[data-yc-status]').textContent = message; }
      error(message) { const box = this.querySelector('[data-yc-error]'); box.textContent = message; box.hidden = !message; }
      scheduleNote(delay) {
        clearTimeout(this.noteTimer);
        if (this.note.value !== this.savedNote) this.querySelector('[data-yc-note-status]').textContent = this.s.saving;
        this.noteTimer = setTimeout(() => this.enqueue(() => this.saveNote()).catch(() => {}), delay);
      }
      async saveNote() {
        if (!this.note || this.note.value === this.savedNote) return;
        const value = this.note.value;
        try {
          const cart = await this.request('cart/update.js', {note:value});
          if ((cart.note || '') !== value) throw new Error(this.s.note_error);
          this.savedNote = value;
          this.querySelector('[data-yc-note-status]').textContent = this.note.value === value ? this.s.note_saved : this.s.saving;
        } catch (error) { this.querySelector('[data-yc-note-status]').textContent = this.s.note_error; throw error; }
      }
      async submit(event) {
        if (event.target.matches('[data-yc-shipping-form]')) { event.preventDefault(); this.estimate(); return; }
        if (!event.target.matches('[data-yc-cart-form]') || this.nativeSubmit) return;
        event.preventDefault();
        if (this.checkingOut) return;
        const inputs = [...this.querySelectorAll('[data-yc-quantity]')];
        if (inputs.some(input => !input.checkValidity())) { inputs.find(input => !input.checkValidity()).reportValidity(); return; }
        this.checkingOut = true; this.failedSave = false; this.error('');
        const submitter = event.submitter || this.querySelector('[data-yc-checkout]');
        clearTimeout(this.noteTimer);
        try {
          this.flushQuantities();
          await this.queue;
          if (this.failedSave) return;
          await this.saveNote().catch(() => {});
          this.disable(false);
          this.nativeSubmit = true;
          event.target.requestSubmit(submitter);
        } finally { this.checkingOut = false; }
      }
      async request(path, body) {
        const requestUrl = new URL(this.root + path,window.location.origin);
        const response = await fetch(requestUrl.toString(), {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
        const data = await response.json();
        if (!response.ok || data.status >= 400) { const error = new Error(typeof data.description === 'string' ? data.description : this.s.error); error.customerMessage = error.message; throw error; }
        return data;
      }
      render(cart) {
        const html = cart.sections?.[this.dataset.section];
        if (!html) throw new Error(this.s.error);
        const source = new DOMParser().parseFromString(html,'text/html').querySelector('yds-cart');
        if (!source) throw new Error(this.s.error);
        for (const slot of ['items','totals']) this.querySelector('[data-yc-' + slot + ']').innerHTML = source.querySelector('[data-yc-' + slot + ']').innerHTML;
        this.querySelector('[data-yc-empty]').hidden = cart.item_count > 0;
        this.querySelector('[data-yc-full]').hidden = cart.item_count === 0;
        this.querySelector('[data-yc-shipping]').hidden = !cart.requires_shipping;
        this.config.currency = typeof cart.currency === 'string' ? cart.currency : cart.currency.iso_code;
        this.clearEstimate();
      }
      sectionUrl() { const url = new URL(window.location.href); if (this.previewId) url.searchParams.set('preview_theme_id',this.previewId); return url; }
      async refresh() {
        const cartUrl = new URL(this.root+'cart.js',window.location.origin);
        const response = await fetch(cartUrl.toString(),{headers:{'Accept':'application/json'},cache:'no-store'});
        if (!response.ok) throw new Error(this.s.error);
        const cart = await response.json();
        const url = this.sectionUrl(); url.searchParams.set('sections',this.dataset.section);
        const sectionResponse = await fetch(url.toString(),{cache:'no-store'});
        if (!sectionResponse.ok) throw new Error(this.s.error);
        cart.sections = await sectionResponse.json(); this.render(cart); this.cart = cart;
      }
      provinces() {
        const country = this.querySelector('[name="country"]');
        const province = this.querySelector('[name="province"]');
        const pairs = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
        province.replaceChildren(new Option(this.s.choose_region,''));
        for (const [value,label] of pairs) province.add(new Option(label,value));
        province.required = pairs.length > 0; province.disabled = !pairs.length;
        this.querySelector('[data-yc-province-wrap]').hidden = !pairs.length;
      }
      clearEstimate(message = '') {
        this.version++; this.shippingAbort?.abort(); this.rates = [];
        this.querySelector('[data-yc-estimate-result]').hidden = true;
        const wrap = this.querySelector('[data-yc-rate-wrap]'); if (wrap) wrap.hidden = true;
        const status = this.querySelector('[data-yc-rate-status]'); if (status) status.textContent = message;
        this.querySelector('[data-yc-shipping-fallback]').hidden = false;
        const button = this.querySelector('.yc__estimate-button'); if (button) button.disabled = false;
      }
      money(cents) {
        const format = this.config.money_format;
        const match = format?.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/);
        if (!match) return new Intl.NumberFormat(document.documentElement.lang || 'en-NZ',{style:'currency',currency:this.config.currency}).format(cents / 100);
        const token = match[1];
        const decimals = token.includes('no_decimals') ? 0 : 2;
        const comma = token.includes('comma_separator');
        const group = token.includes('space_separator') ? ' ' : token.includes('apostrophe_separator') ? "'" : comma ? '.' : ',';
        const parts = (cents / 100).toFixed(decimals).split('.');
        const amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,group) + (decimals ? (comma ? ',' : '.')+parts[1] : '');
        return new DOMParser().parseFromString(format.replace(match[0],amount),'text/html').body.textContent;
      }
      async estimate() {
        const form = this.querySelector('[data-yc-shipping-form]');
        const zip = form.elements.zip; const country = form.elements.country.value;
        if (['New Zealand','Australia'].includes(country) && !/^\d{4}$/.test(zip.value.trim())) { zip.setCustomValidity(this.s.postcode_error); zip.reportValidity(); return; }
        if (!form.reportValidity()) return;
        this.clearEstimate();
        const version = this.version;
        const status = this.querySelector('[data-yc-rate-status]');
        const button = form.querySelector('button'); button.disabled = true; status.textContent = this.s.loading;
        const abort = new AbortController(); this.shippingAbort = abort;
        const timeout = setTimeout(() => abort.abort(),18000);
        const params = new URLSearchParams();
        for (const key of ['country','province','zip']) params.set('shipping_address['+key+']',form.elements[key].value.trim());
        try {
          this.flushQuantities(); await this.queue;
          if (version !== this.version) return;
          const prepared = await fetch(this.root+'cart/prepare_shipping_rates.json?'+params,{method:'POST',headers:{'Accept':'application/json'},signal:abort.signal});
          if (!prepared.ok) throw new Error(this.s.unavailable);
          let result = null;
          for (let attempt=0;attempt<12;attempt++) {
            if (attempt) await new Promise(resolve => setTimeout(resolve,900));
            if (abort.signal.aborted) throw new Error(this.s.unavailable);
            const response = await fetch(this.root+'cart/async_shipping_rates.json?'+params,{headers:{'Accept':'application/json'},signal:abort.signal,cache:'no-store'});
            if (!response.ok) throw new Error(this.s.unavailable);
            result = await response.json(); if (result !== null) break;
          }
          if (version !== this.version) return;
          const rates = result?.shipping_rates;
          if (!Array.isArray(rates) || !rates.length) throw new Error(this.s.unavailable);
          if (country !== this.dataset.country) throw new Error(this.s.market_note);
          this.rates = rates.filter(rate => typeof rate.price === 'string' && /^\d+(\.\d{1,2})?$/.test(rate.price) && (!rate.currency || rate.currency === this.config.currency));
          if (!this.rates.length) throw new Error(this.s.unavailable);
          const select = this.querySelector('[data-yc-rate]'); select.replaceChildren(new Option(this.s.choose,''));
          this.rates.forEach((rate,index) => select.add(new Option((rate.presentment_name || rate.name)+' — '+this.money(Math.round(Number(rate.price)*100)),String(index))));
          this.querySelector('[data-yc-rate-wrap]').hidden = this.rates.length === 1;
          status.textContent = this.rates.length > 1 ? this.s.choose : '';
          if (this.rates.length === 1) { select.value = '0'; this.displayRate(0); }
        } catch (error) {
          if (version === this.version) status.textContent = error.message === this.s.market_note ? this.s.market_note : this.s.unavailable;
        } finally { clearTimeout(timeout); if (version === this.version) button.disabled = false; }
      }
      displayRate(index) {
        const rate = this.rates[index];
        if (!rate) { this.querySelector('[data-yc-estimate-result]').hidden = true; this.querySelector('[data-yc-shipping-fallback]').hidden = false; return; }
        const cents = Math.round(Number(rate.price)*100);
        this.querySelector('[data-yc-service]').textContent = rate.presentment_name || rate.name;
        this.querySelector('[data-yc-price]').textContent = this.money(cents);
        this.querySelector('[data-yc-estimated-total]').textContent = this.money(this.cart.total_price+cents);
        this.querySelector('[data-yc-estimate-result]').hidden = false;
        this.querySelector('[data-yc-shipping-fallback]').hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yds-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('yds-cinematic-hero'))customElements.define('yds-cinematic-hero',class extends HTMLElement{
 connectedCallback(){
  if(this.initialized)return;this.initialized=true;this.inView=false;this.userPaused=false;this.mode='';
  this.layer=this.querySelector('[data-cinema-video]');this.control=this.querySelector('[data-cinema-motion]');this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  this.onControl=()=>{this.userPaused=!this.userPaused;this.toggleAttribute('data-user-paused',this.userPaused);this.control.setAttribute('aria-label',this.userPaused?this.dataset.resumeLabel:this.dataset.pauseLabel);this.syncPlayback()};
  this.control.addEventListener('click',this.onControl);this.onVisibility=()=>this.syncPlayback();document.addEventListener('visibilitychange',this.onVisibility);
  this.onPreference=()=>{if(this.reduced.matches){this.clearVideo();this.mode=''}else this.selectVideo()};this.reduced.addEventListener('change',this.onPreference);
  this.resize=new ResizeObserver(()=>this.selectVideo());this.resize.observe(this);
  this.intersection=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;if(this.inView)this.selectVideo();this.syncPlayback()},{threshold:.05});this.intersection.observe(this);
 }
 clearVideo(){if(this.video){this.video.pause();this.video.removeAttribute('src');this.video.load();this.video=null}this.layer.replaceChildren();this.removeAttribute('data-video-ready');this.control.hidden=true}
 selectVideo(){
  if(!this.inView||this.reduced.matches||navigator.connection?.saveData)return;
  const mode=this.clientWidth<750?'mobile':'desktop';if(mode===this.mode)return;this.mode=mode;this.clearVideo();
  const content=this.querySelector('[data-cinema-'+mode+']')?.content;if(!content)return;this.layer.append(content.cloneNode(true));this.video=this.layer.querySelector('video');if(!this.video)return;
  this.video.muted=true;this.video.defaultMuted=true;this.video.addEventListener('playing',()=>{if(!this.video)return;this.setAttribute('data-video-ready','');this.control.hidden=false});
  this.video.addEventListener('error',()=>{this.removeAttribute('data-video-ready');this.control.hidden=true});this.syncPlayback();
 }
 syncPlayback(){if(!this.video)return;if(this.inView&&!document.hidden&&!this.userPaused&&!this.reduced.matches){const result=this.video.play();result?.catch(()=>{if(!this.hasAttribute('data-video-ready'))this.control.hidden=true})}else this.video.pause()}
 disconnectedCallback(){this.resize?.disconnect();this.intersection?.disconnect();document.removeEventListener('visibilitychange',this.onVisibility);this.reduced?.removeEventListener('change',this.onPreference);this.control?.removeEventListener('click',this.onControl);this.clearVideo();this.initialized=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yds-home-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yds-nature-film')) customElements.define('yds-nature-film', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.poster = this.querySelector('[data-nature-play]');
    this.player = this.querySelector('.yds-nature-film__player');
    this.back = this.querySelector('.yds-nature-film__back');
    if (!this.poster || !this.player || !this.back || !/^[\w-]{11}$/.test(this.dataset.videoId || '')) return;
    this.poster.setAttribute('role', 'button');
    const play = event => {
      event.preventDefault();
      if (this.player.querySelector('iframe')) return;
      const iframe = document.createElement('iframe');
      iframe.title = this.dataset.videoTitle;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + this.dataset.videoId + '?autoplay=1&rel=0';
      this.player.append(iframe);
      this.poster.hidden = true;
      this.player.hidden = false;
      this.back.hidden = false;
      iframe.focus();
    };
    const reset = () => {
      this.player.replaceChildren();
      this.player.hidden = true;
      this.back.hidden = true;
      this.poster.hidden = false;
      this.poster.focus();
    };
    this.poster.addEventListener('click', play, {signal});
    this.poster.addEventListener('keydown', event => { if (event.key === ' ') play(event); }, {signal});
    this.back.addEventListener('click', reset, {signal});
    this.addEventListener('keydown', event => { if (event.key === 'Escape' && !this.player.hidden) { event.preventDefault(); reset(); } }, {signal});
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; this.player?.replaceChildren(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yds-native-design-story"] && !Shopify.designMode) return;
  try {
    
  function connectNativeVisualisers() {
    document.querySelectorAll('[data-native-visualiser]').forEach(section => {
      if (section.dataset.connected) return;
      const root = Array.from(document.querySelectorAll('[data-yds-room-visualiser]')).find(node => node.dataset.productHandle === section.dataset.nativeVisualiser);
      const launch = root && root.querySelector('[data-yds-rv-open]');
      if (!launch) return;
      section.dataset.connected = 'true';
      const update = () => { section.hidden = root.hidden || root.dataset.ydsRvReady !== 'true'; };
      new MutationObserver(update).observe(root, { attributes: true, attributeFilter: ['hidden', 'data-yds-rv-ready'] });
      section.querySelectorAll('[data-native-visualiser-open]').forEach(button => button.addEventListener('click', () => launch.click()));
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectNativeVisualisers);
  else connectNativeVisualisers();
  document.addEventListener('shopify:section:load', connectNativeVisualisers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yds-olivia-artist"]) return;
  try {
    
(() => {
  if (window.ydsOliviaRabbitWiggle) {
    window.ydsOliviaRabbitWiggle.init(document);
    return;
  }
  const active = new Map();
  const selector = '[data-olivia-rabbit]';
  const elements = scope => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  function init(scope) {
    elements(scope).forEach(button => {
      if (active.has(button)) return;
      const image = button.querySelector('img');
      if (!image) return;
      const motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      let timer;
      let wiggling = false;
      const finish = () => {
        window.clearTimeout(timer);
        wiggling = false;
        button.classList.remove('is-wiggling');
      };
      const wiggle = () => {
        if (wiggling || !motion || motion.matches) return;
        wiggling = true;
        button.classList.add('is-wiggling');
        timer = window.setTimeout(finish, 750);
      };
      const onEnd = event => { if (event.target === image && event.animationName === 'olivia-rabbit-wiggle') finish(); };
      const onMotion = () => { if (motion.matches) finish(); };
      const cleanup = () => {
        finish();
        button.removeEventListener('click', wiggle);
        image.removeEventListener('animationend', onEnd);
        motion?.removeEventListener?.('change', onMotion);
        active.delete(button);
      };
      button.addEventListener('click', wiggle);
      image.addEventListener('animationend', onEnd);
      motion?.addEventListener?.('change', onMotion);
      active.set(button, cleanup);
    });
  }
  const unload = scope => {
    for (const [button, cleanup] of active) if (scope === button || scope.contains(button)) cleanup();
  };
  window.ydsOliviaRabbitWiggle = { init, unload };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yds-olivia-design-story"]) return;
  try {
    
if(!customElements.get('yds-olivia-made-logo')){
  customElements.define('yds-olivia-made-logo',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.image=this.querySelector('img');
      if(!this.image||!window.matchMedia||!window.IntersectionObserver)return;
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible=false;
      this.played=false;
      this.onMotion=()=>{if(this.motion.matches)this.settle();else this.play()};
      this.motion.addEventListener?.('change',this.onMotion);
      this.observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          this.visible=entry.isIntersecting&&entry.intersectionRatio>=.35;
          if(this.visible)this.play();else this.settle();
        });
      },{threshold:[0,.35]});
      this.observer.observe(this);
    }
    play(){
      if(this.played||this.loading||!this.visible||this.motion.matches||!this.isConnected)return;
      this.loading=true;
      const preload=new Image();
      this.preload=preload;
      preload.onload=()=>{
        preload.onload=null;
        preload.onerror=null;
        this.loading=false;
        if(!this.visible||this.motion.matches||!this.isConnected)return;
        this.played=true;
        this.image.src=this.image.dataset.gif;
        this.timer=setTimeout(()=>this.settle(),3000);
      };
      preload.onerror=()=>{this.played=true;this.settle()};
      preload.src=this.image.dataset.gif;
    }
    settle(){
      clearTimeout(this.timer);
      if(this.preload){this.preload.onload=null;this.preload.onerror=null}
      this.loading=false;
      if(this.image&&this.image.src!==this.image.dataset.still)this.image.src=this.image.dataset.still;
    }
    disconnectedCallback(){
      this.settle();
      this.observer?.disconnect();
      this.motion?.removeEventListener?.('change',this.onMotion);
      this.ready=false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yds-olivia-owner-review"]) return;
  try {
    
function initOliviaOwnerPurchase(root){root.querySelectorAll('[data-owner-purchase]').forEach(card=>{if(card.dataset.ready)return;card.dataset.ready='true';const select=card.querySelector('[data-owner-size]');const price=card.querySelector('[data-owner-price]');select.addEventListener('change',()=>{price.textContent=select.selectedOptions[0].dataset.price;});});}initOliviaOwnerPurchase(document);document.addEventListener('shopify:section:load',event=>initOliviaOwnerPurchase(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yds-olivia-range-product"]) return;
  try {
    
function initOliviaPurchase(root){const sections=[...root.querySelectorAll('[data-olivia-purchase]')];if(root.matches?.('[data-olivia-purchase]'))sections.unshift(root);sections.forEach(section=>{if(section.dataset.oliviaPurchaseReady)return;section.dataset.oliviaPurchaseReady='true';const select=section.querySelector('[data-olivia-variant]');const button=section.querySelector('[data-olivia-add]');const price=section.querySelector('[data-olivia-price]');const panels=section.querySelector('[data-olivia-panels]');const sync=()=>{const option=select?.selectedOptions[0];if(!option)return;if(price)price.textContent=option.dataset.price;if(panels)panels.hidden=option.dataset.panels!=='2';if(button){const preview=section.dataset.reviewOnly==='true';button.disabled=preview||option.dataset.available!=='true';button.textContent=preview?'Add to cart — draft preview':option.dataset.available==='true'?'Add to cart':'Sold out';}};select?.addEventListener('change',sync);section.querySelector('form')?.addEventListener('submit',event=>{if(section.dataset.reviewOnly==='true'||button?.disabled)event.preventDefault();});sync();});}initOliviaPurchase(document);document.addEventListener('shopify:section:load',event=>initOliviaPurchase(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yds-resene-staff"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.yrs-made-logo img').forEach(img => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let timer, visible = false;
  const settle = () => { clearTimeout(timer); img.onload = null; img.onerror = null; img.src = img.dataset.still; };
  const play = () => {
    if (motion.matches) { settle(); return; }
    clearTimeout(timer);
    img.onload = () => { img.onload = null; timer = setTimeout(settle, 3200); };
    img.onerror = settle;
    img.src = img.dataset.gif;
  };
  new IntersectionObserver(entries => {
    entries.forEach(entry => { const entering = entry.isIntersecting && entry.intersectionRatio >= 0.5; if (entering && !visible) play(); else if (!entering && visible) settle(); visible = entering; });
  }, { threshold: [0, 0.5] }).observe(img);
  motion.addEventListener('change', () => { if (motion.matches) settle(); else if (visible) play(); });
});
if (!customElements.get('yds-resene-book')) {
  customElements.define('yds-resene-book', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.pages = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.index = 0;
      this.mobile = matchMedia('(max-width: 749px)');
      this.onResize = () => { if (!this.mobile.matches) if (this.index > 0 && this.index % 2 === 0) this.index -= 1; this.render(); };
      this.mobile.addEventListener('change', this.onResize);
      this.querySelector('.yrs-book__pages').addEventListener('click', () => this.move(1));
      this.querySelector('.yrs-book__pages').addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.move(1); } });
      this.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.move(e.key === 'ArrowLeft' ? -1 : 1); } });
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1));
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1));
      this.querySelector('.yrs-book__controls').hidden = false;
      this.render();
    }
    disconnectedCallback() { this.mobile?.removeEventListener('change', this.onResize); }
    move(direction) {
      if (direction > 0 && this.index >= this.pages.length - 1) return;
      const step = this.mobile.matches || (direction > 0 && this.index === 0) ? 1 : 2;
      this.index = Math.max(0, Math.min(this.pages.length - 1, this.index + direction * step));
      this.render();
    }
    image(page, eager = false) {
      const img = document.createElement('img');
      img.className = 'yrs-book__page';
      img.width = page.width; img.height = page.height;
      img.alt = this.dataset.pageLabel + ' ' + page.page;
      img.loading = eager ? 'eager' : 'lazy';
      img.src = page.url;
      img.addEventListener('error', () => { this.querySelector('.yrs-book__error').hidden = false; });
      return img;
    }
    render() {
      const count = this.mobile.matches || this.index === 0 || this.index === this.pages.length - 1 ? 1 : 2;
      this.visiblePages = this.pages.slice(this.index, this.index + count);
      this.querySelector('.yrs-book__error').hidden = true;
      this.querySelector('.yrs-book__pages').replaceChildren(...this.visiblePages.map(page => this.image(page)));
      this.querySelector('[data-prev]').disabled = this.index === 0;
      this.querySelector('[data-next]').disabled = this.index + count >= this.pages.length;
      this.querySelector('.yrs-book__pages').setAttribute('aria-disabled', String(this.index + count >= this.pages.length));
      const range = count === 1 ? String(this.index + 1) : (this.index + 1) + '–' + Math.min(this.index + count, this.pages.length);
      this.querySelector('.yrs-book__status').textContent = (count === 1 ? this.dataset.pageLabel : this.dataset.pagesLabel) + ' ' + range + ' ' + this.dataset.ofLabel + ' ' + this.pages.length;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
